module.exports = __webpack_public_path__ + "static/media/icons-checkin.f9e0660d.svg";